import * as React from 'react';
import {FunctionComponent} from 'react';

import {GraphTimeSpan} from '../swagger';

export interface GraphTimeSpanComponentProps {
    currentGraphTimeSpan: GraphTimeSpan;
    changeGraphTimeSpanHandler: (v: GraphTimeSpan) => void;
}

const graphTimeSpanOptions = [
    {key: GraphTimeSpan.Hour, label: '1h'},
    {key: GraphTimeSpan.Day, label: '1d'},
];

export const GraphTimeSpanComponent: FunctionComponent<GraphTimeSpanComponentProps> = ({currentGraphTimeSpan, changeGraphTimeSpanHandler}) => (
    <ul className="bg-m-gray-2 mr-3 rounded">
        {graphTimeSpanOptions.map((o) => {
            return (
                <li className="inline-block px-1 py-px" key={o.key}>
                    <button
                        className={
                            `font-normal font-roboto-regular px-1 rounded-md text-sm sm:text-base ${currentGraphTimeSpan === o.key ? 'btn-primary font-bold' : ''}`
                        }
                        onClick={(e) => {
                            changeGraphTimeSpanHandler(e.currentTarget.value as GraphTimeSpan);
                        }}
                        value={o.key}
                    >
                        {o.label}
                    </button>
                </li>
            );
        })}
    </ul>
);
